// TUILS
import { defineStore } from "pinia"
import { ref, computed } from "vue"

// STORES
import { useHelpStore } from "@/components/af/Help/help.store.js"

// MACHINE
import { moveBisActor } from "@/features/movebis/machines/moveBisMachine"

// TYPES
import type { Ref } from "vue"
import type { Question } from "@/features/movebis/store/movebis.types"

// API
import { getQuestions, getAudio } from "@/api/s3/index"

export const useQuestionsStore = defineStore("moveBisQuestionsStore", () => {
  const helpStore = useHelpStore()

  // Ref
  const initalItems: Ref<Question[]> = ref([])
  const items: Ref<Question[]> = ref([])
  const currentIndex: Ref<number> = ref(0)
  const isLastQuestion: Ref<boolean> = ref(false)
  const dimensions: Ref<string[]> = ref([])

  // Computed
  const currentQuestion = computed<Question>(() => {
    return items.value[currentIndex.value]
  })
  const questionsLength = computed(() => items.value.length)

  /**
   * Fetch the questions from the API
   * @returns The questions data
   */
  async function fetchQuestions() {
    const data = await getQuestions({ test: "movebis" })
    items.value = data.questions
    initalItems.value = data.questions

    items.value = items.value.filter(
      (item) => dimensions.value && dimensions.value.includes(item.dimension)
    )

    return items.value
  }

  /**
   * Fetch the audios from the API
   */
  function fetchAudios() {
    getAudio({ test: "movebis" })
  }

  /**
   * Go to the next question
   */
  async function goNext() {
    if (currentIndex.value === items.value.length - 1) {
      isLastQuestion.value = true
      moveBisActor.send({ type: "done" })
    } else {
      currentIndex.value++
      if (helpStore.isAudioHelpAccepted) {
        helpStore.startAudioSequence()
      }
    }
  }

  /**
   * Set the current index
   * @param id The index to set
   */
  function setCurrentIndex(id: number) {
    currentIndex.value = id
  }

  /**
   * Set the dimensions to filter the questions
   * @param _dimensions The dimensions to filter
   */
  function setDimensions(_dimensions: string[]) {
    dimensions.value = _dimensions
  }

  /**
   * Get the initial items
   * @returns The initial items
   */
  function getItems() {
    return initalItems.value
  }

  return {
    getItems,
    questions: items.value,
    currentIndex,
    currentQuestion,
    questionsLength,
    fetchQuestions,
    fetchAudios,
    goNext,
    isLastQuestion,
    setCurrentIndex,
    setDimensions,
  }
})
